module.exports = __webpack_public_path__ + "static/media/posterS1-1.3f714025.png";